'use strict'

exports = module.exports = require('./build/input').default

module.exports['default'] = require('./build/input').default


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/custom.js
// module id = 502
// module chunks = 1 2